var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevron2 = function SvgChevron2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 5 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.71 9.391a.765.765 0 0 1-.454-.145.65.65 0 0 1-.174-.19.578.578 0 0 1-.05-.48.611.611 0 0 1 .132-.216l3.173-3.371-3.06-3.377a.609.609 0 0 1-.129-.218.562.562 0 0 1 .058-.48.654.654 0 0 1 .178-.189C.457.668.543.625.636.6A.793.793 0 0 1 1.2.65c.085.043.16.1.218.17l3.42 3.773a.587.587 0 0 1 .162.4.587.587 0 0 1-.161.398L1.297 9.165a.707.707 0 0 1-.263.175.788.788 0 0 1-.324.051Z",
    fill: "currentColor"
  })));
};
export { SvgChevron2 as ReactComponent };